<template>
    <div v-if="fields">
        <div
            @click="onClick()"
            class="card mx-5 my-5 text-center elevation-10"
            :class="{ clickable: fields.button }"
        >
            <div class="stripe" :class="colorClass" />
            <h3 class="py-5 title-weight info--text">{{ fields.title }}</h3>
            <div
                ref="desc"
                v-if="fields.description"
                :style="{ 'min-height': descHeight ? descHeight + 'px' : '' }"
                class="primary white--text pa-5 d-flex align-center"
            >
                {{ fields.description }}
            </div>
            <h4 v-if="fields.subTitle" class="primary--text my-5 title-weight">
                {{ fields.subTitle }}
            </h4>
            <div class="pa-3">
              <ctf-rich-text :document="fields.body" />
            </div>
            </div>
        <hidden-btn
            v-if="fields.button"
            :btn-id="fields.button.sys.id"
            ref="btn"
        />
    </div>
</template>

<script>
import { queryEntryCTF } from '../../../plugins/contentful'
import HiddenBtn from '@/components/snippets/hidden-btn'
export default {
  name: 'PlanCard',
  components: {
    HiddenBtn
  },
  props: {
    sysId: {
      type: String,
      required: true
    },
    descHeight: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      fields: null,
      dialog: false
    }
  },
  computed: {
    colorClass () {
      switch (this.fields.color) {
      case 'yellow':
        return 'yellow'
      case 'orange':
        return 'error'
      case 'green':
        return 'accent'
      default:
        return 'primary'
      }
    }
  },
  async created () {
    const { fields } = await queryEntryCTF(this.sysId)
    this.fields = fields
    // wait until fields are rendered
    this.$nextTick(() => {
      if (this.$refs.desc) {
        this.$emit('descHeightChanged', this.$refs.desc.clientHeight)
        this.currentHeight = this.$refs.desc.clientHeight
      }
    })
  },
  methods: {
    onClick () {
      if (this.$refs.btn) {
        this.$refs.btn.click()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/variables';

.card {
    width: 375px;
    max-width: 90vw;
    min-height: 465px;
    background-color: $white;
    .stripe {
        width: 100%;
        height: 12px;
    }
    .title-weight {
        font-weight: $font-weight-semi-bold;
    }
}
</style>
